/**
 * Copyright (C) 2026 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */

import React from 'react';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import WhatsNewBadgeIcon from './WhatsNewBadgeIcon';
import appTheme from '../theme/appTheme.json';

export interface WhatsNewPanelMenuButtonProps {
  latestChecksum?: string;
  userLastViewedChecksum?: string;
  onClick: () => void;
}

const WhatsNewPanelMenuButton: React.FC<WhatsNewPanelMenuButtonProps> = ({
  latestChecksum,
  userLastViewedChecksum,
  onClick,
}) => {
  const shouldShowWhatsNewBadge = !!latestChecksum && latestChecksum !== userLastViewedChecksum;

  return (
    <MenuItem
      onClick={onClick}
      sx={{
        background: appTheme.mptPrimaryBackgroundColor,
        padding: '8px 16px',
        alignItems: 'center',
        '&:hover': {
          background: appTheme.mptRowBorderBottom,
        },
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px', minWidth: '50px' }}>
        <WhatsNewBadgeIcon showBadge={shouldShowWhatsNewBadge} />
        <Typography
          sx={{
            fontFamily: appTheme.appFontFamily,
            fontSize: '12px',
            fontWeight: 600,
            lineHeight: '16px',
            color: appTheme.secondaryHeaderTextColor,
          }}
        >
          What's new
        </Typography>
      </Box>
    </MenuItem>
  );
};

export default WhatsNewPanelMenuButton;
